import React from 'react';
import { DrawerBody } from '@one-thd/sui-atomic-components';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import { FloatingDatePill } from './subcomponents/FloatingDatePill';
import { useDrawer } from './DrawerProvider';
import { DrawerInput } from './subcomponents/DrawerInput';
import { DrawerInputWithFileUpload } from './subcomponents/DrawerInputWithFileUpload';

// The drawer BODY frame (scrollable message area + composer). See .claude/context/drawer-layout.md.
export const DrawerContent = ({ children, overlay = null }) => {
  const isUploadEnabled = useConfigService('magic-apron-file-upload-enabled');

  const { onScroll, scrollEl, drawerState } = useDrawer();

  // Use drawerState instead of CSS media queries for mobile
  const isMinimized = drawerState === 'MINIMIZED';

  // Inline, not a class: see .claude/context/drawer-layout.md ("MINIMIZED peek").
  const bodyStyle = {
    overscrollBehavior: 'contain',
    zIndex: 0,
    ...(isMinimized && { padding: 0 }),
  };

  const drawerBodyClasses = classnames(
    'sui-flex sui-flex-col sui-justify-stretch sui-flex-1 sui-min-h-0 sui-relative',
  );

  return (
    <div id="magic-apron-drawer-content" data-component="DrawerContent" className={drawerBodyClasses}>
      {/* Takeover slot (the post-chat survey): covers the composer too, and is sized by this
          element's definite height. See .claude/context/drawer-layout.md */}
      {overlay}
      <DrawerBody
        overflow="scroll"
        style={bodyStyle}
        data-testid="drawer-body"
        ref={scrollEl}
        onScroll={onScroll}
      >
        {!isMinimized && <FloatingDatePill />}
        {children}
      </DrawerBody>
      {!isMinimized && (
        <div className="sui-shrink-0">
          {isUploadEnabled ? <DrawerInputWithFileUpload /> : <DrawerInput />}
        </div>
      )}
    </div>
  );
};

DrawerContent.propTypes = {
  children: PropTypes.node.isRequired,
  overlay: PropTypes.node,
};
